<template>
    <!-- 有问必答 -->
    <div class="contaier">
        <Title-b :title="$t('Side.answer')" />
        <!-- <p class="p">有问必答</p> -->
        <div style="display: flex;justify-content: center;width:1000px;margin-top:20px">
            <div class="total">                                         
                <div v-for="(item,index) in s" :key="index+1" class="one" :class=" flaot +1 == index +2 ? name1:name2" @click="helpcenterByIdArticle(item,index+1)">
                    {{item.typename}}
                </div>
                <!-- <div  class="one gong1">
                    {{s.typename}}
                </div> -->
            </div>
        </div>
        <div class="news">
            <div v-for="(item,index) in newssdadad" :key="index" @click="Djquestion(item, index)">
                <div v-if="item.Type == 1 && flaot == 1">{{item.Title}} <span>{{item.CreateTime}}</span></div>
                <div v-if="item.Type == 2 && flaot == 2">{{item.Title}}</div>
                <div v-if="item.Type == 3 && flaot == 3">{{item.Title}}</div>
                <div v-if="item.Type == 4 && flaot == 4">{{item.Title}}</div>
            </div>
        </div>
        <div>
      <div class="modal-mask" v-show="QuestionInfo">
        <div class="frame_box">
          <div class="frame_title">
            {{ TitleOne }}
          </div>
          <img
            src="../../../assets/images/chahao.png"
            alt=""
            @click="QuestionInfo = false"
          />
          <div class="frame-container">
            <div v-html="news.Text">
              {{ news.Text }}
            </div>
            <div class="frame-time"></div>
          </div>
          <div class="fc_footer" @click="QuestionInfo = false">
            {{ $t("Home.Ialreadyknow") }}
          </div>
        </div>
      </div>
    </div>
    </div>
</template>
<script>
export default {
    data(){
        return{
            name1:"gong1",
            name2:"gong2",
            flaot:0,
            show1:true,
            show2:false,
            show3:false,
            show4:false,
            news:[],
            newss:[],
            Article:[],
            time:[],
            QuestionInfo:false,
            index:0,
            s:{},
            newssdadad: [],
            TitleOne: "",
        }
    },
    mounted(){
        this.getQuestion();
        this.helpcenter();
        // this.typeGetQuestion();
    },
    methods:{
        async getQuestion(){
            const params = {MemberID:localStorage.getItem("userID")};
            const { data } = await this.$post("GetQuestion",params);
            if(data.State){
                this.newssdadad = JSON.parse(data.ReturnJson).QuestionInfo;
            }
        },
        // 标签名称
        async helpcenter(){
            const params = {MemberID:localStorage.getItem("userID")};
            const { data } = await this.$post("Helpcenter",params);
            if(data.State){
                this.s = JSON.parse(data.ReturnJson);
            }
        },
        async helpcenterByIdArticle(item,index){ 
            this.flaot = index;
            const params = {
                MemberID:localStorage.getItem("userID"),
                id:item.id,
                CusID:23
            };
            const { data } = await this.$post("HelpcenterByIdArticle",params);
            if(data.State){
                this.Article = JSON.parse(data.ReturnJson)
                localStorage.setItem("token", Article.Token);
            }
        },
        
        async Djquestion(item, index) {
            var JsonData = { ID: item.id };
            const { data } = await this.$post("GetDesctionById", JsonData);
            if (data.State) {
                this.TitleOne = item.Title;
                this.news = JSON.parse(data.ReturnJson);
            }
            this.QuestionInfo = true;
            this.index = index;
        },
    },
}
</script>
<style lang="scss" scoped>
    .modal-mask {
        position: fixed;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
        z-index: 9999;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.3);
        overflow: auto;
    .frame_box{
      height: 664px;
      display: block;
      width: 900px;
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      background: #fff;
      display: flex;
      flex-direction: column;
      img{
        width: 23px;
        height: 23px;
        position: absolute;
        right: 29px;
        cursor: pointer;
        top: 33px;
      }
      .frame_title{
        padding: 30px 0;
        margin: 0 30px;
        border-bottom: 1px solid #ddd;
        text-align: center;
        font-size: 20px;
        font-weight: 500;
      }
      .frame-container{
        padding: 30px;
        flex: 1;
        overflow: auto;
        .frame-time{
          @include color($_color);
          font-size: 16px;
          text-align: right;
        }
      }
      .fc_footer{
        width: 150px;
        height: 40px;
        line-height: 40px;
        text-align: center;
        border-radius: 20px;
        @include backgroundColor($_color);
        font-size: 16px;
        color: #fff;
        cursor: pointer;
        margin: 15px auto;
      }
    }
    }
    .contaier{
        width: 1069px;
        // height: 700px;
        border-radius: 5px;
        background: #fff;
        padding: 19px 17px;
        .total{
            display: flex;
            flex-direction: row;
            text-align: center;
            color: #fff;
            font-size: 20px;
            line-height: 60px;
            .gong1{
                @include backgroundColor($_color);
            }
            .gong2{
                //  @include backgroundColor($_color);
                background: #2d8cf08f;;
            }
            .one{
                position:relative;
                width: 220px;
                height: 60px;
                // padding: 0px 60px;
                margin: 0 20px;
                // margin-left: 80px;
                color: #fff;
                cursor: pointer;
                .absolute{
                    position: absolute;
                    top: 52px;
                    left: 91px;
                }
            }
            .two{
                width: 280px;
                height: 60px;
                position: relative;
                margin-left: 35px;
                cursor: pointer;
                .absolute{
                    position: absolute;
                    top: 52px;
                    left: 91px;
                }
            }
            .three{
                width: 280px;
                position: relative;
                height: 60px;
                margin-left: 35px;
                cursor: pointer;
                .absolute{
                    position: absolute;
                    top: 52px;
                    left: 91px;
                }
            }
            .four{
                width: 280px;
                position: relative;
                height: 60px;
                margin-left: 35px;
                cursor: pointer;
                .absolute{
                    position: absolute;
                    top: 52px;
                    left: 93px;
                }
            }
        }
        .news{
            margin: 44px 79px;
            cursor: pointer;
            >div{
                >div{
                    margin: 14px 0;
                    border-bottom: 1px dashed;
                    height: 29px;
                    span{
                        float: right;
                    }
                }
                >div:hover{
                     @include color($_color);
                    // @include color($color);
                }
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/pages/view/memberservices/answer.vue